/* eslint-disable max-lines-per-function */
import React, { useContext, useEffect } from "react";
import { Alert, Button, Icon } from "antd";
import { Waypoint } from "react-waypoint";
import ReactGA from "react-ga4";

import { googleAds } from "appConfig";

import getWidthContext from "../../HOCs/getWidthContext";
import styles from "./styles/HomePage.scss";

import OtherCategories from "./OtherCategories";
import PopularCategories from "./PopularCategories/PopularCategories";
import Statistics from "./Statistics";
import SearchBar from "./SearchBar";
import Logo from "../App/Logo";
import { isMediumScreen, isMobileScreen, scrollToTop } from "../../services";
import NewAdsSection from "../ModulePage/NewAdsSection/NewAdsSection";
import HelmetComponent from "../../utils/HelmetHelper";
import { Context } from "../../GAContext";
import { CurrentPage, PageRoute, SearchMode } from "../../models";
import { useDispatch, useSelector } from "react-redux";
import { deleteControls } from "../../routes/Search/search.ducks";
import history from "../../history";
import { getImageUrl } from "../../services/asset";
import GoogleAd from "../../components/GoogleAd";
import GoogleAdInterstitial from "../../components/GoogleAdInterstitial";
import { RecommendedAdsCarousel } from "./RecommendedAdsCarousel/RecommendedAdsCarousel";
import { selectIsAiMode } from "../App/selectors";
import { setAIFeedbackModalVisible, updateSearchMode } from "../App/actions";


function HomePage({
  showHeaderLogoAndSearchBar,
  hideHeaderLogoAndSearchBar,
  width,
  onSubmitAdClick,
  location
}) {
  const handleLogoClick = () => {
    window.location.reload();
  };
  const [GaEvent, setGaEvent] = useContext(Context);
  const isMedium = isMediumScreen(width);
  const isMobile = isMobileScreen(width);
  const dispatch = useDispatch();

  const handleClassicSearchClick = () => {
    dispatch(updateSearchMode(SearchMode.classic))
  }

  const handleLeaveCommentClick = () => {
    dispatch(setAIFeedbackModalVisible(true))
  }

  const isAiMode = useSelector(selectIsAiMode)

  useEffect(() => {
    dispatch(deleteControls());

    if (location.state && location.state.scroll) {
      scrollToTop();
      history.replace({ pathname: "/", state: null });
    }

    setGaEvent(CurrentPage.home);

    const params = new URLSearchParams(location.search);
    const isFromIndexPortalParam = params.get("isFromIndexPortal")
    if (isFromIndexPortalParam) {
      ReactGA.event({
        category: "Cijene nekretnina widget",
        action: "Click",
        label: `logo kliknut`
      });

    }


    return () => {
      setGaEvent("");

      if (!isMedium) {
        showHeaderLogoAndSearchBar();
      }
    };
  }, []);

  return (
    <React.Fragment>
      <HelmetComponent
        title="Index Oglasi"
        ogTitle="Index Oglasi"
        ogImage={getImageUrl("logo.png")}
      />

      {isMobile && (
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
      )}


      <div className={isMedium ? styles.topSectionsMobile : styles.topSections}>
        {isMedium ? null : <Logo onClick={handleLogoClick} />}
        {isMedium ? (
          <span className={styles.searchBar}>
            {/* 
                This empty span resolves the IOS glitch. The search bar wouldn't be shown only on the homepage if it is not here. 
                I assume that some renders are causing this problem and IOS can't calculate the boundaries of the modal to display.
                If you try in xCode emulator and just turn off and on any css attribute, it will apply all necessary styles and will be fine.
            */}
            <span> </span>
            <SearchBar isMobile={isMedium} isHomePage={true} />
          </span>
        ) : (
          <Waypoint
            onLeave={showHeaderLogoAndSearchBar}
            onEnter={hideHeaderLogoAndSearchBar}
          >
            <span className={styles.searchBar}>
              <SearchBar isMobile={isMedium} isHomePage={true} />
            </span>
          </Waypoint>
        )}

        {isAiMode && (
          <div style={{
            color: "#868686",
            marginTop: 15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 4,
            flexDirection: isMobile ? "column" : "row",
          }} >

            <span>
              <Icon type="exclamation-circle-o" style={{ marginRight: 8 }} />
              Testna verzija AI pretrage
            </span>
            {!isMobile && <span> · </span>}
            <span>
              <span onClick={handleClassicSearchClick} className={styles.searchTypeLink}>
                prebaci na klasičnu
              </span>
              <span> · </span>
              <span onClick={handleLeaveCommentClick} className={styles.searchTypeLink}>
                ostavi komentar
              </span>
            </span>
          </div>

        )}

        {isMedium && (
          <div className={`child-center ${styles.submitContainer}`}>
            <Button
              className={styles.submitAdBtn}
              onClick={onSubmitAdClick}
              type={isMedium ? "default" : "primary"}
            >
              <span className={styles.orText}>{"ili"}</span>
              <span className={styles.submitAdText}>
                {"objavi besplatan oglas"}
              </span>
            </Button>
          </div>
        )}


        {isMobile ? (
          <div className={styles.boxAd}>
            <GoogleAd
              className={styles.ads}
              config={{
                ...googleAds.homePageMobile.box1,
                id: "googleAds.homePageMobile.box1"
              }}
              noTopMargin={true}
            />
          </div>
        ) : null}

        <PopularCategories isMobile={isMobile} />

        {isMobile ? (
          <div className={styles.boxAd}>
            <GoogleAd
              className={`${styles.ads} ${styles.adPlaceholder2}`}
              config={{
                ...googleAds.homePageMobile.box2,
                id: "googleAds.homePageMobile.box2"
              }}
            />
          </div>
        ) : (
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.homePage.top,
              id: "googleAds.homePage.top"
            }}
          />
        )}

        <OtherCategories showGoogleAds={isMobile} />

        {isMobile ? (
          <div className={styles.boxAd}>
            <GoogleAd
              className={styles.ads}
              config={{
                ...googleAds.homePageMobile.box4,
                id: "googleAds.homePageMobile.box4"
              }}
            />
          </div>
        ) : (
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.homePage.bottom1,
              id: "googleAds.homePage.bottom1"
            }}
            noBottomMargin={true}
          />
        )}
        <RecommendedAdsCarousel />
        <NewAdsSection isMobile={isMobile} showDetails={false} isHomePage={true} />
        {isMobile ? null : (
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.homePage.bottom2,
              id: "googleAds.homePage.bottom2"
            }}
          />
        )}

      </div>

      {isMobile ? (
        <div className={styles.boxAd}>
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.homePageMobile.box5,
              id: "googleAds.homePageMobile.box5"
            }}
          />
        </div>
      ) : null}
      <Statistics />
    </React.Fragment>
  );
}

export default getWidthContext(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.tsx